<div class="form-group mt-4 mt-lg-0">
  <button (click)="loginTM()" class="btn btn-primary btn-block login-button font-size-14 w-100 d-flex justify-content-center">
    <span>Login with <img src="assets/images/ticketmaster.svg" class="tm-logo ms-1" /></span>
  </button>
</div>
